<template>
  <div style="height: 100%">
    <slot></slot>

    <modal-container>
      <continue-session-modal ref="continueSession"/>
    </modal-container>
  </div>
</template>

<script>
import {DateTime} from "luxon";
import auth from "../../api/auth";
import router from "../../router";
import ContinueSessionModal from "../../modules/auth/components/ContinueSessionModal.vue";

export default {
  name: "LayoutBase",
  components: {ContinueSessionModal},
  mounted() {
    this.checkSession();
    setInterval(this.checkSession, 60 * 1000 * process.env.MIX_SESSION_CHECK_INTERVAL_IN_MINUTES);
  },
  methods: {
    checkSession() {
      const sessionTimeoutAt = this.$store.state.sessionTimeout;

      if (sessionTimeoutAt) {
        const now = DateTime.now();
        const timeToLogoutAt = sessionTimeoutAt.minus({minutes: process.env.MIX_SESSION_LOGOUT_BEFORE});
        const openModalAt = sessionTimeoutAt.minus({minutes: process.env.MIX_SESSION_OPEN_MODAL_BEFORE});

        if (now >= timeToLogoutAt) {
          auth.logout().then(() => {
            router.push({name: 'login'});
          });
        } else if (now >= openModalAt) {
          this.$refs.continueSession.open();
        }
      }
    },
  }
}
</script>
